<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    *ngIf="
        (process$ | async)?.ProcessID == 64 ||
        (process$ | async)?.ProcessID == 90
    "
    [observables]="[timecards$]"
></ef-loading-container>
<ef-loading-container
    *ngIf="
        (process$ | async)?.ProcessID == 87 ||
        (process$ | async)?.ProcessID == 85
    "
    [observables]="[directReportTimeStatusData$]"
></ef-loading-container>
<ef-loading
    *ngIf="this.timerActive == true"
    [processing]="timerActive"
    [processingText]="timerMessage"
    [loading]="timerActive"
></ef-loading>
<ef-time-card-presenter
    [managementActionResp]="managementActionResponse$ | async"
    [timecardData]="timecards$ | async"
    [process]="process$ | async"
    [companySettings]="companySettings$ | async"
    [weeklySummaryData]="weeklySummaryData$ | async"
    [directReportTimeStatusData]="directReportTimeStatusData$ | async"
    [directReports]="directReports$ | async"
    [signaturePolicy]="signaturePolicy$ | async"
    [userWebColors]="userWebColors$ | async"
    [timecardSequence]="timecardSequence$ | async"
    (LoadDirectReportsWithTimeStatus)="
        onLoadDirectReportsWithTimeStatus($event)
    "
    (LoadSignaturePolicy)="onLoadSignaturePolicy($event)"
    (LoadTimecardSequence)="onLoadTimecardSequence($event)"
    (SaveTimecardSequence)="onSaveTimecardSequence($event)"
    (LoadMgmtLoadTimecardandWeeklySummary)="
        onMgmtLoadTimecardandWeeklySummary($event)
    "
>
</ef-time-card-presenter>
